<script setup lang="ts">
defineOptions({
	name: 'TransfersSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-solar:global-linear"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Are there international transfers') }}?
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						'In the event of international data transfers, Gaveta Decimal is committed to conducting such transfers in full compliance with applicable legal provisions',
					)
				}}.
			</p>
		</div>
	</section>
</template>
